import { makeStyles } from 'tss-react/mui';

export default makeStyles<{ active?: boolean }>({ name: 'LicenseMenuItem' })((_theme, props) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 4px',
        gap: 16,
        borderRadius: 8,
        alignItems: 'stretch',
        textAlign: 'initial'
    },
    line: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    tag: {
        display: 'flex',
        padding: '0px 4px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 96,
        border: '1px solid #BEDCFF',
        background: '#E3F2FF',
        color: '#4180F0',
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px'
    },
    name: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px'
    },
    radio: {
        width: 16,
        height: 16,
        borderRadius: '50%',
        border: props.active ? '4px solid #2D2D2D' : '1px solid #ECECEC',
        boxSizing: 'border-box',
        marginRight: 6
    },
    issue: {
        marginTop: 8,
        marginBottom: 8
    }
}));
